import { IsAdminLoggedIn, RegisterMode } from "@app/dev/actions/terminal";
import Config from "@app/dev/config/main";
import { PopupContext } from "@app/dev/contexts/popup";
import TooltipDropDown from "@common/components/tooltipDropDown";
import { POPUPS } from "@common/constants/popups";
import { useTranslation } from "@common/hooks/translation";
import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";

import './style.scss';

const AdminDropDown = () => {
  const dispatch = useDispatch();
  const [{ openPopup }] = useContext(PopupContext);
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslation();

  const optionsData = [
    {
      buttonName: "Admin",
      iconName: "icon-login-admin-menu",
      enabled: true,
      callback: () => openPopup(POPUPS.LOGIN_FORM, { signInToAdmin: Config.terminal.signInToAdmin, popupPosition: 'top' }),
    },
    {
      buttonName: "Registr Player",
      iconName: "icon-deposit-player-account",
      enabled: true,
      callback: () => {
        dispatch(RegisterMode(true));
        openPopup(POPUPS.RFID_CHECK_POPUP);
      },
    },
    {
      buttonName: "Log out",
      iconName: "icon-logout",
      enabled: true,
      callback: () => dispatch(IsAdminLoggedIn(false)),
    },
  ];

  const menuHeader = (
    <>
      <i className="global-icon icon-login-admin icon-admin-icon" />
      <h2>{t("Admin")}</h2>
      <i className={`menu-toggle-icon global-icon ${isOpen ? "icon-thin-arrow-up" : "icon-thin-arrow-down"}`} />
    </>
  );

  return (
    <TooltipDropDown
      header={menuHeader}
      options={optionsData}
      className="admin-dropdown-section"
      onToggle={setIsOpen}
    />
  );
};

export default AdminDropDown;
